/**
 * Any getters for easy access to things in store
 */
export const getters = {
  getUserFeed: state => state.feed,
  getProps: state => state.defaultProps,
  getIcon: () => 'grid'
};
